// extracted by mini-css-extract-plugin
module.exports = {"ad":"ad-1WzoVqKH","box":"box-3EEANLEB","footer":"footer-1jXFnwnR"};